import actions from './actions'

const initialState = {
  id: '',
  name: '',
  // role: '',
  email: '',
  groups: [],
  customerId: null,
  customerName: '',
  authorized: false,
  loading: true,
}

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
